<template>
  <div :class="{ active: selected, checked: isChecked}" class="customer-table__entry">
    <!-- Image -->
    <div @click="handleSelect(customer)" class="customer-table__item customer-table__image">
      <div class="customer-table__avatar">
        <placeholder-avatar :initials="initials"/>
      </div>
      <div class="customer-table__check">
        <q-checkbox v-model="checked" />
      </div>
    </div>

    <!-- Name -->
    <div @click="handleSelect(customer)" :class="{ 'small': small }" class="customer-table__item customer-table__name">
      <span class="q-body-2">{{ customer.name }}</span>
    </div>

    <!-- Email -->
    <div v-show="!small" class="customer-table__item customer-table__email gt-lg">
      <a :href="'mailto:' + email">{{ email }}</a>
    </div>

    <!-- Phone -->
    <div v-show="!small" class="customer-table__item customer-table__phone gt-lg">
      {{ phone }}
    </div>

    <!-- Tools -->
    <div v-show="!small" class="customer-table__item customer-table__tools">
      <q-btn icon="more_vert" color="grey-7" flat round dense>
        <customer-popover :customers="[customer]"></customer-popover>
      </q-btn>
    </div>

    <!-- Deselect -->
    <div v-show="selected" @click="handleDeselect" class="customer-table__item customer-table__deselect">
      <q-icon name="close" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import CustomerPopover from '../CustomerPopover.vue'
  import PlaceholderAvatar from 'src/components/Common/PlaceholderAvatar.vue'

  export default {
    data () {
      return {
        checked: false
      }
    },

    computed: {
      ...mapGetters(['selectedCustomer', 'activeTeam', 'checkedCustomers']),

      small () {
        return this.selectedCustomer !== null
      },

      selected () {
        return this.selectedCustomer && parseInt(this.customer.id) === parseInt(this.selectedCustomer.id)
      },

      phone () {
        return this.customer.default_phone_number ? this.customer.default_phone_number.data.number : ''
      },

      email () {
        return this.customer.default_email_address ? this.customer.default_email_address.data.email : ''
      },

      initials () {
        return this.customer.name.charAt(0).toUpperCase()
      },

      isChecked () {
        return this.checkedCustomers.includes(this.customer)
      }
    },

    props: {
      customer: {
        type: Object,
        required: true
      }
    },

    methods: {
      ...mapActions(['deselectCustomer', 'checkCustomer']),

      handleSelect (company) {
        this.$router.push({ name: 'customer', params: { customerId: company.id, teamId: this.activeTeam.id } })
      },

      handleDeselect () {
        this.deselectCustomer()
          .then(this.$router.push({ name: 'customers', params: { teamId: this.activeTeam.id } }))
      }
    },

    watch: {
      checked (newVal, oldVal) {
        this.checkCustomer({ customer: this.customer, value: newVal })
      }
    },

    components: {
      CustomerPopover,
      PlaceholderAvatar
    }
  }
</script>
